import { validateEmail } from "../../constants/functions";

export function pnrValidator(pnr: string) {
  if (/[^a-zA-Z0-9]/.test(pnr)) return "PNR should not contain special characters";
  return "";
}

export const lastNameValidator = (name: string) => {
  const validCharacters = /^[a-zA-Z]+$/;
  if (name.match(validCharacters)) return "Please Enter a valid Last name";
  return "";
};

export const emailValidator = (emailId: string) => {
  if (validateEmail(emailId)) return "";
  return "Please enter a valid email address";
};

export const lastNameOrEmailValidator = (value: string) => {
  const validCharacters = /^[a-zA-Z\s-]+$/;
  if (value.includes("@")) {
    if (validateEmail(value)) return "";
    return "Please enter a valid email address";
  }
  if (value.match(validCharacters)) {
    return "";
  }
  return "Please Enter a valid Last Name";
};
